import { withHandlers } from 'recompose'
import { compose } from 'redux'
import InformationalMessage from './InformationalMessage'

const withCloseMessageHandler = withHandlers({
  closeInfoMessage: ({ setIsInfoMessageVisible }) => () => {
    setIsInfoMessageVisible(false)
  }
})

export default compose(
  withCloseMessageHandler
)(InformationalMessage)
